export default "__VITE_ASSET__5e5ff384__"